import { c as _c } from "react/compiler-runtime";
import { CustomLink } from '@/app/_components/CustomLink';
import { NOTICE_CATEGORY_TYPE } from '@/app/donation/constants';
import { DONATION_ROUTES } from '@/constants';
interface NoticeListItemProps {
  title: string;
  dday: string;
  categoryType: string;
  noticeId: number;
}
export const NoticeListItem = t0 => {
  const $ = _c(14);
  const {
    title,
    dday,
    categoryType,
    noticeId
  } = t0;
  const isBadgeShow = categoryType === NOTICE_CATEGORY_TYPE.WINNER_ANNOUNCEMENT;
  let t1;
  if ($[0] !== isBadgeShow) {
    t1 = isBadgeShow && <p className="w-fit rounded-xsmall bg-O-25 px-6 pb-2 pt-4 font-600 text-O-300 typo-caption1">당첨자 발표</p>;
    $[0] = isBadgeShow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== noticeId) {
    t2 = DONATION_ROUTES.MY_ETC_NOTICE_DETAIL.pathname({
      noticeId
    });
    $[2] = noticeId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${title} 상세 페이지로 이동`;
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== title) {
    t4 = <CustomLink href={t2} className="font-500 text-Gray-900 typo-body3" aria-label={t3}>{title}</CustomLink>;
    $[4] = t2;
    $[5] = t3;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== dday) {
    t5 = <p className="font-400 text-Gray-550 typo-caption1">{dday}</p>;
    $[8] = dday;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <li className="flex flex-col gap-8 border-b border-Gray-200 p-20">{t1}{t4}{t5}</li>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};